import { GlobalRole } from "@prisma/client";
import * as Factory from "factory";
import * as faker from "faker";
export const userWithoutIds = async ({ ...args } = {})=>{
    const { id, ...user } = await userFactory.build({
        ...args
    });
    return user;
};
export const userFactory = Factory.Async.makeFactory({
    id: Factory.Async.each(async (i)=>i),
    createdAt: Factory.Async.each(async ()=>new Date()),
    updatedAt: Factory.Async.each(async ()=>new Date()),
    name: Factory.Async.each(async ()=>faker.name.firstName()),
    email: Factory.Async.each(async ()=>faker.internet.email()),
    isBotUser: false,
    hashedPassword: Factory.Async.each(async ()=>faker.internet.password()),
    role: Factory.Async.each(async ()=>GlobalRole.CUSTOMER)
});
